// extracted by mini-css-extract-plugin
module.exports = {"copyableButton":"CopyableInput_copyableButton__1LbIk"};